import React, { FC } from 'react';

import Individual from './IndividualForm';
import LegalForm from './LegalForm';

type Props = {
  typeContractor: number | null;
};

const MainInfoTab: FC<Props> = ({ typeContractor }) => {
  if (typeContractor === null || typeContractor === undefined) {
    return null;
  }

  return <div>{typeContractor === 2 ? <Individual /> : <LegalForm />}</div>;
};

export default MainInfoTab;
